class Delete {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
    }
    init() {
        document.querySelectorAll('[data-delete]').forEach(el => {
            new DeleteGroup(el)
        })
    }
}

class DeleteGroup {
    constructor(el) {
        this.el = el
        this.init()
    }
    init() {
        this.el.querySelectorAll('input[type=hidden]').forEach(el => {
            new DeleteItem(el.parentElement)
        })

        const observer = new MutationObserver(el => {
            el.forEach(el => {
                el.addedNodes.forEach(el => {
                    if (el.nodeType === 1) {
                        new DeleteItem(el)
                    }
                })
            })
        });
        observer.observe(this.el, { attributes: true, childList: true, subtree: true });
    }
}
class DeleteItem {
    constructor(el) {
        this.el = el
        this.init()
    }
    init() {
        this.el.addEventListener('click', e => {
            e.preventDefault()
            this.el.remove()
        });
    }
}

export default Delete